import i18n from '@/utils/i18n';
import React from 'react';
import { CompositeNavigationProp, RouteProp } from '@react-navigation/native';
import { NEW_ORDER_ROUTES, SUBSTITUTION_ROUTES } from '@/navigators/routes';
import {
  NewOrderStackParams,
  SubstitutionStackParams,
} from '@/navigators/types';
import { PageContainer } from '@/components/page-container';
import { SelectSubstitutionQuantityContent } from '@/components/substitutions/select-substitution-quantity-content';
import { StackNavigationProp } from '@react-navigation/stack';

interface Props {
  navigation: CompositeNavigationProp<
    StackNavigationProp<
      SubstitutionStackParams,
      SUBSTITUTION_ROUTES.SelectSubstitutionQuantity
    >,
    StackNavigationProp<NewOrderStackParams, NEW_ORDER_ROUTES.OrderSummary>
  >;
  route: RouteProp<
    SubstitutionStackParams,
    SUBSTITUTION_ROUTES.SelectSubstitutionQuantity
  >;
}

export const SelectSubstitutionQuantity: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const {
    itemWithSubstitute,
    substituteListOption,
    substitutionQuantity,
    orderUUID,
  } = route.params;

  return (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        showBackButton: true,
        showShadow: false,
        title: i18n.t('select_quantity'),
      }}
    >
      <SelectSubstitutionQuantityContent
        itemWithSubstitute={itemWithSubstitute}
        onSetSubstitution={(substitutionChoices) => {
          // pass merge: true to preserve nav params from the original order
          // summary entry point (like smartOrderUUID).
          navigation.navigate({
            merge: true,
            name: NEW_ORDER_ROUTES.OrderSummary,
            params: {
              initialSubstitution: {
                substitutionChoices,
                substitutionVariantPackUUID:
                  itemWithSubstitute.substitution?.original_variant_pack.uuid!,
              },
            },
          });
        }}
        orderUUID={orderUUID}
        substituteListOption={substituteListOption}
        substitutionAvailableQuantity={substitutionQuantity}
      />
    </PageContainer>
  );
};
